import React, { useState } from "react";
import AddProgrammingEvalForm from "./addProgrammingEvalForm";
import useWindowWidth from "./useWindowWidth";
import NewProgrammingExamIcon from "./newProgrammingExamIcon";
import ImportEval from "./importEval";

const AddProgrammingEval = (props) => {
    const [adding, setAdding] = useState(false);
    const [isImporting, setIsImporting] = useState(false);
    const width = useWindowWidth(800);

    function updateIsImporting(newValue) {
        setIsImporting(newValue);
    }

    const updateCreating = (bool) => {
        setAdding(bool)
        props.updateCreating(bool)
    }

    return (
        <>
            {
                props.prevCourses && props.prevCourses?.length > 0 && (
                    <div className={`add-course basic-container`} onClick={ () => {updateIsImporting(true)} } style={{ columnGap: "10px", width: width ? "60px" : "140px", paddingLeft: width ? "10px" : "", paddingRight: width ? "10px" : "" }}>
                        {
                            width

                            ?

                            <>
                                { "Add" }
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0"/>
                                </svg>
                            </>

                            :

                            <>                    
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0"/>
                                </svg>
                                { "Import Eval" }
                            </>
                        }
                    </div>
                )
            }            
            <div className={`add-course basic-container`} onClick={ () => {updateCreating(true)} } style={{ columnGap: "10px", width: width ? "60px" : "140px", paddingLeft: width ? "10px" : "", paddingRight: width ? "10px" : "" }}>
                {
                    width

                    ?

                    <>
                        { "New" }
                        <NewProgrammingExamIcon />
                    </>

                    :

                    <>                    
                        <NewProgrammingExamIcon />
                        { "New Evaluation" }
                    </>
                }
            </div>
            { adding || props.creating ? <AddProgrammingEvalForm updateCreating={updateCreating} dockerArray={props.dockerArray}/> : <></> }
            { isImporting ? <ImportEval prevCourses={props.prevCourses} prevEvals={props.prevEvals} updateIsImporting={updateIsImporting}/> : <></> }
        </>
    );
}

export default AddProgrammingEval;